import { Injectable } from "@angular/core";
import { Subject, Observable } from "rxjs";

@Injectable()
export class LocalStorageService {
  private storageEventSubject = new Subject<StorageEvent>();

  constructor() {
    window.addEventListener("storage", (event: StorageEvent) => {
      if (event.key === "examready") {
        this.storageEventSubject.next(event);
      }
    });
  }

  // Observable to listen for storage changes
  storageChangeEvent(): Observable<StorageEvent> {
    return this.storageEventSubject.asObservable();
  }

  setItem(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key: string): any {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/localStorage.service.ts